import Skeleton from "react-loading-skeleton";
import styles from "./product-page-skeleton.module.css";

const ProductPageSkeleton = () => {
  return (
    <div className={styles.container}>
      <div className={styles.gallery}>
        <div className={styles.mainImage}>
          <Skeleton width="100%" height="100%" />
        </div>
        <div className={styles.thumbnailRow}>
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className={styles.thumbnail}>
              <Skeleton width="100%" height="100%" />
            </div>
          ))}
        </div>
      </div>

      <div className={styles.details}>
        <div className={styles.titleBlock}>
          <Skeleton width="100%" height="38%" className={styles.titlePrimary} />
          <Skeleton width="85%" height="38%" />
        </div>

        <div className={styles.contentBlock}>
          <div className={styles.splitRow}>
            <div className={styles.splitItem}>
              <Skeleton height="100%" />
            </div>
            <div className={styles.splitItem}>
              <Skeleton height="100%" />
            </div>
          </div>
          <div className={styles.footerBlock}>
            <Skeleton width="100%" height="100%" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPageSkeleton;
